import app from 'flarum/common/app';

app.initializers.add('shebaoting/repost', () => {
  console.log('[shebaoting/repost] Hello, forum and admin!');
});
